import { render, staticRenderFns } from "./StockSourceList.vue?vue&type=template&id=8e9ad23a&scoped=true"
import script from "./StockSourceList.vue?vue&type=script&lang=js"
export * from "./StockSourceList.vue?vue&type=script&lang=js"
import style0 from "./StockSourceList.vue?vue&type=style&index=0&id=8e9ad23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9ad23a",
  null
  
)

export default component.exports